import { render, staticRenderFns } from "./customer-sale-date.vue?vue&type=template&id=f476b530"
import script from "./customer-sale-date.vue?vue&type=script&lang=js"
export * from "./customer-sale-date.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports